export default "__VITE_ASSET__DHQQFBD4__"